// 空状态生成器：购物卡（shopping）
export function createEmptyShoppingPayload() {
  return {
    card_type: 'shopping',
    type: 'shopping',
    title: '请输入购物地点名称',
    imageUrl: 'https://images.unsplash.com/photo-1481437156560-3205f6a55735?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2095',
    address: '请填写地址',
    description: '这里请填写购物地点的描述',
    metaPairs: [],
    tags: [],
    card: {},
  };
}
